import { ExportTicketsModal } from './ExportTicketsModal';
import { withExportTicketsModal } from './withExportTicketsModal';

const connectExportTicketsModal = withExportTicketsModal(ExportTicketsModal);

export { connectExportTicketsModal as ExportTicketsModal };
